import { Component, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { InstanceConfigService } from 'src/app/core/services/instance-config.service';

@Component({
  selector: 'instance-header',
  standalone: true,
  imports: [AsyncPipe],
  template: `
    <div class="hero-container">
      <div class="hero-image" [style.backgroundImage]="'url(assets/courthouse.png)'"></div>
      <div class="hero-overlay"></div>
      <div class="hero-content container">
        <div class="text-content">
          <p class="hero-eyebrow">{{siteTitle$ | async}}</p>
          <h1>Inmate records search</h1>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./instance-header.component.scss']
})
export class InstanceHeaderComponent {
  readonly siteTitle$ = this.instanceConfigService.siteTitle$;

  constructor(
    private readonly instanceConfigService: InstanceConfigService
  ) {}
}